import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// メインAPI（インターセプターあり）
const apiClient = axios.create({ baseURL: API_BASE_URL });
// リフレッシュ専用（インターセプターなし）
const refreshClient = axios.create({ baseURL: API_BASE_URL });

// --- token utils ---
const getAccessToken = () => localStorage.getItem("accessToken");
const getRefreshToken = () => localStorage.getItem("refreshToken");
const setToken = (access, refresh) => {
  if (access) localStorage.setItem("accessToken", access);
  if (refresh) localStorage.setItem("refreshToken", refresh);
};
apiClient.setToken = setToken;

const handleLogout = () => {
  console.warn("[handleLogout] called! clearing tokens and (normally) redirecting");

  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("user");
  window.location.href = "/Login?reason=timeout";
};

// --- refresh without interceptors ---
async function fetchNewAccessToken() {
  const refresh = getRefreshToken();
  if (!refresh) throw new Error("No refresh token");

  console.log("[refresh] POST", `${refreshClient.defaults.baseURL}/api/token/refresh/`);
  const res = await refreshClient.post("/api/token/refresh/", { refresh });
  console.log("[refresh] status:", res.status, "data:", res.data);

  const { access, refresh: newRefresh } = res.data || {};
  setToken(access, newRefresh || refresh);
  return access;
}

// --- request interceptor ---
apiClient.interceptors.request.use(
  (config) => {
    const token = getAccessToken();
    if (token) {
      config.headers = config.headers ?? {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// --- response interceptor with queue ---
let isRefreshing = false;
let queue = [];
const runQueue = (err, token = null) => {
  queue.forEach(({ resolve, reject }) => (err ? reject(err) : resolve(token)));
  queue = [];
};

apiClient.interceptors.response.use(
  (res) => res,
  async (error) => {
    const { config: originalRequest = {}, response } = error || {};
    const status = response?.status;

    if (!response) return Promise.reject(error);

    const url = String(originalRequest.url || "");
    if (url.includes("/api/token/refresh/") || url.includes("/api/accounts/login/")) {
      return Promise.reject(error);
    }

    console.warn("[401?] status:", status, "url:", url, "hasAccess?", !!getAccessToken(), "hasRefresh?", !!getRefreshToken());
    console.log("[api] baseURL:", API_BASE_URL);

    if (status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          queue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers = originalRequest.headers ?? {};
            originalRequest.headers.Authorization = `Bearer ${token}`;
            return apiClient(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      isRefreshing = true;
      try {
        const newToken = await fetchNewAccessToken();
        runQueue(null, newToken);
        originalRequest.headers = originalRequest.headers ?? {};
        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        return apiClient(originalRequest);
      } catch (e) {
        runQueue(e, null);
        handleLogout();
        return Promise.reject(e);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

export default apiClient;
